function getMulFile ({
  limit,
  fileType,
  isActive
}) {
  !limit && (limit = 2)
  return new Promise((resolve, reject) => {
    limit = 1024
    let
      fileEle = document.createElement('input'),
      event = new MouseEvent('click')
    fileEle.type = "file"
    // 是否选择文件夹  true选择
    fileEle.webkitdirectory = isActive
    fileEle.accept = fileType || ""
    fileEle.style.display = 'none'
    fileEle.multiple = "multiple"
    fileEle.addEventListener('change', () => {
      console.log('files', fileEle.files);
      const files = fileEle.files
      const raw = files
      if (isActive) {
        resolve(fileEle.files)
      } else {
        files.size / (1024 ** 2) > limit
          ? reject(`文件不能超过${limit}MB!`)
          : resolve(raw)
      }
      document.body.removeChild(fileEle)
    })
    fileEle.dispatchEvent(event)
    document.body.appendChild(fileEle)
  })
}
export default getMulFile